// @flow

import React from "react";
import { localize } from "redux-i18n";
import { SimpleGrid, WistiaPlayer } from "@components";

type Props = PropsFromLocalize;

class HelpPanelAbsenceDetails extends React.Component<Props> {
  get typeData() {
    return [
      {
        id: "standart-reports",
        label: this.props.t("STANDART_REPORTS"),
        details: this.props.t("STANDART_REPORTS_INTRODUCTION"),
      },
      {
        id: "my-reports",
        label: this.props.t("MY_REPORTS"),
        details: this.props.t("MY_REPORTS_INTRODUCTION"),
      },
    ];
  }

  get formatData() {
    return [
      {
        id: "most-absences",
        label: this.props.t("MOST_ABSENCES_CHART"),
        details: this.props.t("AD_MOST_ABSENCES_DESCRIPTION"),
      },
      {
        id: "absences-by-length",
        label: this.props.t("PERCENTAGE_ABSENCES_BY_LENGTH_CHART"),
        details: this.props.t("AD_ABSENCES_BY_LENGTHS_DESCRIPTION"),
      },
      {
        id: "absences-by-staff-group",
        label: this.props.t("PERCENTAGE_ABSENCES_BY_STAFF_GROUP_CHART"),
        details: this.props.t("AD_ABSENCES_BY_STAFF_GROUP_DESCRIPTION"),
      },
      {
        id: "quick-filters",
        label: this.props.t("QUICK_FILTERS"),
        details: this.props.t("QUICK_FILTERS_DESCRIPTION"),
      },
      {
        id: "export-button",
        label: this.props.t("EXPORT_BUTTON"),
        details: this.props.t("EXPORT_BUTTON_DESCRIPTION"),
      },
    ];
  }

  get filtersData() {
    return [
      {
        id: "date-range",
        label: this.props.t("DATE_RANGE"),
        details: this.props.t("DATE_RANGE_DESCRIPTION"),
      },
      {
        id: "from-date",
        label: this.props.t("FROM_DATE"),
        details: this.props.t("FROM_DATE_DESCRIPTION"),
      },
      {
        id: "to-date",
        label: this.props.t("TO_DATE"),
        details: this.props.t("TO_DATE_DESCRIPTION"),
      },
      {
        id: "absence-status",
        label: this.props.t("ABSENCE_STATUS"),
        details: this.props.t("ABSENCE_STATUS_DESCRIPTION"),
      },
      {
        id: "absence-type",
        label: this.props.t("ABSENCE_TYPE"),
        details: this.props.t("ABSENCE_TYPE_DESCRIPTION"),
      },
      {
        id: "absences-filter",
        label: this.props.t("ABSENCES_FILTER"),
        details: this.props.t("ABSENCE_FILTER_DESCRIPTION"),
      },
      {
        id: "work-related",
        label: this.props.t("REPORT_FILTER_WORK_RELATED_ONLY"),
        details: this.props.t("WORK_RELATED_DESCRIPTION"),
      },
      {
        id: "greater-than-days",
        label: this.props.t("ABSENCES_GREATER_THAN_DAYS"),
        details: this.props.t("GREATER_THAN_DAYS_DESCRIPTION"),
      },
      {
        id: "greater-than-days-type",
        label: this.props.t("ABSENCES_GREATER_THAN_DAY_TYPE"),
        details: this.props.t("GRATER_THAN_DAY_TYPE_DESCRIPTION"),
      },
      {
        id: "absence-length",
        label: this.props.t("REPORT_FILTER_ABSENCE_LENGTH"),
        details: this.props.t("ABSENCE_LENGTH_DESCRIPTION"),
      },
      {
        id: "include-leavers",
        label: this.props.t("INCLUDE_LEAVERS"),
        details: this.props.t("INCLUDE_LEAVERS_DESCRIPTION"),
      },
      {
        id: "with-disability",
        label: this.props.t("INCLUDE_EMPLOYEE_WITH_DISABILITY"),
        details: this.props.t("EMPLOYEE_WITH_DISABILITY_DESCRIPTION"),
      },
      {
        id: "gender",
        label: this.props.t("GENDER"),
        details: this.props.t("GENDER_DESCRIPTION"),
      },
      {
        id: "consent-withheld",
        label: this.props.t("CONSENT_WITHHELD_ONLY"),
        details: this.props.t("CONSENT_WITHHELD_DESCRIPTION"),
      },
      {
        id: "absence-reasons",
        label: this.props.t("ABSENCE_REASONS"),
        details: this.props.t("ABSENCE_REASONS_DESCRIPTION"),
      },
      {
        id: "staff-groups",
        label: this.props.t("STAFF_GROUPS"),
        details: this.props.t("STAFF_GROUPS_DESCRIPTION"),
      },
      {
        id: "age-groups",
        label: this.props.t("AGE_GROUPS"),
        details: this.props.t("AGE_GROUPS_DESCRIPTION"),
      },
    ];
  }

  get resultsData() {
    return [
      {
        id: "employee-ref",
        label: this.props.t("EMPLOYEE_REF"),
        details: this.props.t("EMPLOYEE_REF_DESCRIPTION"),
      },
      {
        id: "department",
        label: this.props.t("DEPARTMENT"),
        details: this.props.t("DEPARTMENT_DESCRIPTION"),
      },
      {
        id: "start-date",
        label: this.props.t("START_DATE"),
        details: this.props.t("AD_START_DATE_DESCRIPTION"),
      },
      {
        id: "last-absence-day",
        label: this.props.t("LAST_ABSENCE_DAY"),
        details: this.props.t("AD_LAST_ABSENCE_DAY_DESCRIPTION"),
      },
      {
        id: "rtw-date",
        label: this.props.t("RTW_DATE"),
        details: this.props.t("AD_RTW_DATE_DESCRIPTION"),
      },
      {
        id: "days-lost",
        label: this.props.t("DAYS_LOST"),
        details: this.props.t("AD_DAYS_LOST_DESCRIPTION"),
      },
      {
        id: "absence-type",
        label: this.props.t("ABSENCE_TYPE"),
        details: this.props.t("AD_RESULTS_ABSENCE_TYPE_DESCRIPTION"),
      },
      {
        id: "absence-reason",
        label: this.props.t("ABSENCE_REASON"),
        details: this.props.t("AD_ABSENCE_REASON_DESCRIPTION"),
      },
      {
        id: "status",
        label: this.props.t("STATUS"),
        details: this.props.t("AD_STATUS_DESCRIPTION"),
      },
      {
        id: "absence-id",
        label: this.props.t("ABSENCE_ID"),
        details: this.props.t("AD_ABSENCE_ID_DESCRIPTION"),
      },
    ];
  }

  get columns() {
    return [
      {
        title: this.props.t("ITEM"),
        name: "setting",
        width: 110,
        renderItem: item => item.label,
      },
      {
        title: this.props.t("DESCRIPTION"),
        name: "details",
        renderItem: item => item.details,
      },
    ];
  }

  render() {
    return (
      <div>
        <p className="fs-14">{this.props.t("ABSENCE_DETAILS_INTRODUCTIOM")}</p>
        <h6 className="font-weight-bold">{this.props.t("TUTORIAL")}</h6>
        <div className="mb-3">
          <WistiaPlayer
            videoId={WistiaPlayer.videos.ABSENCE_DETAILS_INSTRUCTIONS}
            title={this.props.t("ABSENCE_DETAILS_INSTRUCTIONS")}
          />
        </div>
        <h6 className="font-weight-bold">{this.props.t("TYPE")}</h6>
        <SimpleGrid className="theme-help" columns={this.columns} rows={this.typeData} />
        <h6 className="font-weight-bold">{this.props.t("FORMAT")}</h6>
        <SimpleGrid className="theme-help" columns={this.columns} rows={this.formatData} />
        <h6 className="font-weight-bold">{this.props.t("FILTERS")}</h6>
        <SimpleGrid className="theme-help" columns={this.columns} rows={this.filtersData} />
        <h6 className="font-weight-bold">{this.props.t("RESULTS")}</h6>
        <SimpleGrid className="theme-help" columns={this.columns} rows={this.resultsData} />
      </div>
    );
  }
}

export default localize()(HelpPanelAbsenceDetails);
